import { Http } from '@/lib/http';

const toBoolean = (value) =>
  value === true || value === 1 || value === 'true' || value === '1';

const toCostCentrePayload = (payload) => ({
  code: payload.code,
  name: payload.name,
  sourceType: payload.sourceType,
  sourceId: payload.sourceId,
  status: payload.status,
  isDefault: toBoolean(payload.isDefault)
});

export class CostCentreCodesService extends Http {
    constructor() {
      super();
      
      this.endpoint = 'gl/settings/cost-centre-codes';
    }

    create(payload) {
      return this.httpClient().post(
        `${this.endpoint}`,
        toCostCentrePayload(payload)
      );
    }
  
    findAll() {
      return this.httpClient().get(`${this.endpoint}`);
    }
  
    update(id, payload) {
      return this.httpClient().patch(
        `${this.endpoint}/${id}`,
        toCostCentrePayload(payload)
      );
    }
  
    delete(id) {
      return this.httpClient().delete(`${this.endpoint}/${id}`);
    }
  }
